import React from 'react'

import { DialogTitle as MuiDialogTitle, DialogTitleProps } from '@material-ui/core'

const DialogTitle: React.FC<DialogTitleProps> = ({ children, ...rest }) => (
  <MuiDialogTitle {...rest}>{children}</MuiDialogTitle>
)

export default DialogTitle
